module.exports = __webpack_public_path__ + "img/seven2Green.fbf10447.jpg";